import { render, staticRenderFns } from "./address-copy-board.vue?vue&type=template&id=05f98cd5&scoped=true&"
import script from "./address-copy-board.vue?vue&type=script&lang=ts&"
export * from "./address-copy-board.vue?vue&type=script&lang=ts&"
import style0 from "./address-copy-board.vue?vue&type=style&index=0&id=05f98cd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f98cd5",
  null
  
)

export default component.exports